import type { SxProps, Theme } from '../../../../themes/themes';

export const getStyles = ({ theme }: { theme: Theme }): { [key: string]: SxProps } => {
  return {
    button: {
      transparent: {
        backgroundColor: 'transparent',
        border: `1px solid transparent`,
        whiteSpace: 'nowrap',
        padding: `${theme.spacing(4)} ${theme.spacing(5)}`,
        '&:hover': {
          backgroundColor: 'transparent',
          border: `1px solid ${theme.palette.grey[50]}`,
        },
        '&:active': {
          backgroundColor: 'transparent',
          border: `1px solid ${theme.palette.grey[50]}`,
        },
        '&:focus': {
          boxShadow: 'none',
          outline: 'none',
        },
        [theme.breakpoints.up('lg')]: {
          padding: `${theme.spacing(4)} ${theme.spacing(6)}`,
        },
      },
      white: {
        backgroundColor: 'transparent',
        border: `1px solid transparent`,
        whiteSpace: 'nowrap',
        padding: `${theme.spacing(4)} ${theme.spacing(5)}`,
        '&:hover': {
          backgroundColor: 'transparent',
          border: `1px solid ${theme.palette.text.primary}`,
        },
        '&:active': {
          backgroundColor: 'transparent',
          border: `1px solid ${theme.palette.text.primary}`,
        },
        '&:focus': {
          boxShadow: 'none',
          outline: 'none',
        },
        [theme.breakpoints.up('lg')]: {
          padding: `${theme.spacing(4)} ${theme.spacing(6)}`,
        },
      },
    },
    buttonActive: {
      transparent: {
        border: `1px solid ${theme.palette.primary.contrastText}`,
      },
      white: {
        border: `1px solid ${theme.palette.text.primary}`,
      },
    },
    outer: {
      display: 'flex',
      overflowX: 'hidden',
      justifyContent: 'flex-start',
      [theme.breakpoints.up('lg')]: {
        justifyContent: 'center',
      },
      userSelect: 'none',
    },
    inner: {
      width: 'auto',
      display: 'flex',
      flexDirection: 'row',
    },
  };
};
